/** Static, compact waveform placeholder — VISTOERA_TENANT_AUDIO_ASSET_
 * CENTER_CANONICAL_UNIFIED_LIBRARY_P0_V1 §10/§11/§12.
 *
 * Deliberately a fixed, hand-authored SVG bar pattern — NEVER a real
 * client-side waveform decode of the actual audio file (task spec §11/§90:
 * "禁止列表加载时客户端完整下载每个音频文件再实时分析 waveform" /
 * `CLIENT_WAVEFORM_FULL_DECODE_ON_LIST_LOAD=NO`). No backend precomputed
 * waveform metadata exists yet either (forensic pass for this task), so
 * every row in the list renders this exact same static shape — a "this
 * item has audio" affordance, never a real amplitude visualization.
 *
 * Two variants:
 * - `audio` (default): a plain neutral bar pattern for any item that has
 *   real, playable audio bytes behind it (`has_preview_audio: true`).
 * - `voiceTemplate`: Voice Template WITHOUT a preview clip yet (task spec
 *   §12: "如果没有 preview audio，则显示 voice template icon / compact
 *   neutral waveform placeholder" — never fabricates an audio file for a
 *   template that doesn't have one).
 */
const BAR_HEIGHTS = [4, 8, 13, 7, 16, 10, 5, 12, 18, 9, 6, 14, 8, 4, 11, 15, 7, 10, 5, 13]

export default function AudioWaveformPlaceholder({
  variant = 'audio',
  width = 64,
  height = 22,
  className,
}: {
  variant?: 'audio' | 'voiceTemplate'
  width?: number
  height?: number
  className?: string
}) {
  const barCount = BAR_HEIGHTS.length
  const barWidth = width / (barCount * 1.6)
  const gap = barWidth * 0.6
  const color = variant === 'voiceTemplate' ? 'var(--text-muted)' : 'var(--primary)'

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      {BAR_HEIGHTS.map((h, i) => {
        const barHeight = (h / 18) * (height - 4)
        const x = i * (barWidth + gap)
        const y = (height - barHeight) / 2
        return (
          <rect
            key={i}
            x={x}
            y={y}
            width={Math.max(1, barWidth)}
            height={Math.max(2, barHeight)}
            rx={barWidth / 2}
            fill={color}
            opacity={variant === 'voiceTemplate' ? 0.45 : 0.75}
          />
        )
      })}
    </svg>
  )
}
